export default __webpack_public_path__ + "static/media/xPurple.f304d3a4.svg";